import DOMPurify from 'dompurify'

type Props = {
  promotionalPhrase: string
}

export const PromotionalPhrase = ({ promotionalPhrase }: Props) => {
  const result = DOMPurify.sanitize(promotionalPhrase)

  return (
    <p
      className="text-[10px] leading-[130%] tracking-[0.15px] font-normal text-white"
      dangerouslySetInnerHTML={{
        __html: result,
      }}
    />
  )
}
